import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export const getDateTo = (dateTo: Date) => {
	dayjs.extend(utc);

	if (dateTo.toDateString() === new Date().toDateString()){
		return dayjs.utc(new Date()).format("YYYY-MM-DD");
	}
	return dayjs(dateTo).format("YYYY-MM-DD");
}